// noinspection JSCheckFunctionSignatures

import * as React from "react";
import {Button, Drawer, Switch} from "@mui/material";
import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import CampaignsShowVets from "./CampaignsShowVets";

export default function CampaignVets({campaignData, vets}) {

	const [addVets,setAddVets] = useState( []);
	const [isOpen, setIsOpen] = React.useState(false);
	const [display, setDisplay] = React.useState([]);
	const [loading, setLoading] = React.useState(true);

	useEffect(() => {

		let arrNew = [];
		let arr = String(campaignData.additional_vets).split(',');
		arr.forEach((x) => {
			if(parseInt(x))
				arrNew.push(parseInt(x));
		})

		setAddVets(arrNew);
		setLoading(false);

	}, []);


	useEffect(() => {

		try {
			let arr = [];
			addVets.forEach((v) => {
				const nme = vets.find(({id}) => id === parseInt(v));
				arr.push(nme.business_name);
			})
			setDisplay(arr);
		} catch (e) {
			setDisplay([])
		}

	}, [addVets]);

	if(loading === true) return null;
	return (
		<div>
			<div><Button onClick={() => setIsOpen(true)} size={"small"} variant={"contained"} style={{marginBottom:10}}>Manage</Button></div>
			<div>
				{
					display.map((x) => {
						return (
							<div>{x}</div>
						)
					})
				}
			</div>
			<OpenDrawer {...{campaignData, vets}} setLoading={setLoading} isOpen={isOpen} setIsOpen={setIsOpen} addVets={addVets} setAddVets={setAddVets} />
		</div>
	)
}

const OpenDrawer = ({vets,isOpen,setIsOpen,setLoading, addVets, setAddVets, campaignData}) => {

	const [filter,setFilter] = useState('');
	const [dataFiltered,setDataFiltered] = useState([]);

	useEffect(() => {

		try {
			if (filter === '') {
				setDataFiltered(vets);
			} else {
				setDataFiltered(vets.filter(({business_name}) => business_name.toLowerCase().includes(filter.toLowerCase())));
			}
		} catch (e) {
			setDataFiltered([]);
		}

	}, [filter, ]);

	return (
		<Drawer anchor={"right"} open={isOpen} onClose={() => {
			setLoading(true);
			setIsOpen(false)
		}}>
			<div style={{padding:20}}>
				<h3>Manage vets not residing in the campaign postcodes</h3>
				<div>
					<input type={"text"} className={"form-control"} style={{margin:'20px 0', width:'100%'}} placeholder={"Search vet..."} value={filter} onChange={(e) => setFilter(e.currentTarget.value)} />
				</div>
				<CampaignsShowVets {...{vets,isOpen,setIsOpen,setLoading}} addVets={addVets} setAddVets={setAddVets} campaignData={campaignData} dataFiltered={dataFiltered}/>
			</div>
		</Drawer>
	)
}
